import createProductFeatures from 'marketing/components/product-features';
import createXhrForm from 'marketing/components/xhrForm';

document.addEventListener('DOMContentLoaded', () => {
    createProductFeatures();
    createXhrForm('[data-agency-form]');
});



// WEBPACK FOOTER //
// ./js/marketing/agency.js